function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

import { HIDE_MESSAGE_NEWS, RESET, SET_COLUMN_ACT_CODE, SET_COLUMN_EVENT_TYPE, SET_MATCHES_HIGHLIGHTING, SET_THEME, SET_WIKIPEDIA_LINKS, THEME_DARK, THEME_LIGHT } from './actions';
export var defaultState = {
  data: {
    theme: THEME_LIGHT,
    matchesHighlighting: true,
    wikipediaLinks: true,
    messageNewsVisible: true,
    // Not used anymore
    columnEventType: true,
    columnActCode: false
  }
};
var LOCAL_STORAGE_KEY = 'settings';

var loadState = function loadState() {
  if (typeof window === 'undefined') {
    return defaultState;
  }

  var storedRawState = localStorage.getItem(LOCAL_STORAGE_KEY);

  if (storedRawState !== null) {
    try {
      var data = JSON.parse(storedRawState);

      if (data == null) {
        // Not allowed
        return defaultState;
      }

      var validateCategory = function validateCategory(allowed) {
        return function (value, defaultValue) {
          return allowed.includes(value) ? value : defaultValue;
        };
      };

      var validateBoolean = function validateBoolean(value, defaultValues) {
        return validateCategory([false, true])(value, defaultValues);
      };

      return {
        data: {
          theme: validateCategory([THEME_LIGHT, THEME_DARK])(data.theme, defaultState.data.theme),
          matchesHighlighting: validateBoolean(data.matchesHighlighting, defaultState.data.matchesHighlighting),
          wikipediaLinks: validateBoolean(data.wikipediaLinks, defaultState.data.wikipediaLinks),
          messageNewsVisible: validateBoolean(data.messageNewsVisible, defaultState.data.messageNewsVisible),
          columnEventType: validateBoolean(data.columnEventType, defaultState.data.columnEventType),
          columnActCode: validateBoolean(data.columnActCode, defaultState.data.columnActCode)
        }
      };
    } catch (e) {
      // Invalid configuration format (?)
      console.error(e);
      return defaultState;
    }
  } else {
    // No configuration stored
    return defaultState;
  }
};

var saveState = function saveState(state) {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state.data));
};

export var initialState = loadState();
export var settingsReducer = function settingsReducer(state, action) {
  switch (action.type) {
    case SET_THEME:
    case SET_MATCHES_HIGHLIGHTING:
    case SET_WIKIPEDIA_LINKS:
    case SET_COLUMN_EVENT_TYPE:
    case SET_COLUMN_ACT_CODE:
    case HIDE_MESSAGE_NEWS:
      var merged = {
        data: _objectSpread(_objectSpread({}, state.data), action.data)
      };
      saveState(merged); // Persist

      return merged;

    case RESET:
      var newState = defaultState;
      saveState(newState);
      return newState;

    default:
      throw new Error();
  }
};